import { createFileRoute } from '@tanstack/react-router'
import { AdminRates } from '../features/admin'
import { rileyRateQuery, techRatesQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/rates')({
  ...adminRouteState,
  loader: ({ context }) =>
    Promise.all([context.queryClient.ensureQueryData(techRatesQuery()), context.queryClient.ensureQueryData(rileyRateQuery())]),
  component: AdminRates,
})
